import { Icon } from "components/icon/Icon";
import { ExternalUser, ExternalUserRole } from "models/customers/customers";
import AddExternalUsers from "./AddExternalUsers";
import ListExternalUsers from "./ListExternalUsers";
import WizardModule from "../wizardmodule/WizardModule";

import "./ExternalUsersEdit.scss";

type Props = {
  showSaveButton: boolean;
  onSaveClick: () => void;
  externalUsers: ExternalUser[];
  onItemAdded: (user: Partial<ExternalUser>, isNew?: boolean) => void;
  onItemRemove: (email: string) => void;
  validUserData: any;
  resetValidUserData?: () => void;
  info?: string;
  collapsed?: boolean;
};

export default function ExternalUsersEdit({
  showSaveButton,
  onSaveClick,
  externalUsers,
  onItemAdded,
  onItemRemove,
  validUserData,
  resetValidUserData,
  info,
  collapsed
}: Props) {
  let list;
  let errorContainer;
  let userErrorContainer;
  if (externalUsers.length > 0)
    {
      list = (
        <ListExternalUsers
          onItemRemove={onItemRemove}
          listItems={externalUsers}
        />
      );
    }

  if (
    externalUsers.length > 0 &&
    externalUsers.filter((u) => u.roles.includes(ExternalUserRole.Admin)).length === 0
  ) {
    errorContainer = (
      <div className="error">
        <Icon name="exclamation-circle" size="lg" />
        <span>Det måste finnas en kundadmin.</span>
      </div>
    );
  }
  if (validUserData === false) {
    userErrorContainer = (
      <div className="userError">
        <Icon name="exclamation-circle" size="lg" />
        <span>
          En användare med angiven e-post eller personnummer finns redan på
          kunden.
        </span>
        <Icon onClick={resetValidUserData} name="close" size="lg" />
      </div>
    );
  }

  return (
    <WizardModule
      showSaveButton={showSaveButton}
      onSaveClick={onSaveClick}
      collapsed={collapsed}
      moduleTitle="Kundanvändare"
      info={info}
    >
      <>
        {list}
        {errorContainer}
        {userErrorContainer}
        <AddExternalUsers
          itemAdded={onItemAdded}
          selectedUsers={externalUsers}
        />
      </>
    </WizardModule>
  );
}
